import React from "react";
import styles from "./screen.module.scss";

const Screen = props => {
  const { map, tray, overlay } = props;
  return (
    <>
      <div className={styles.mapContainer}>
        {map()}
        {overlay ? overlay() : null}
      </div>
      <div className={styles.trackingTray}>{tray()}</div>
    </>
  );
};

export default Screen;
